import downloadFile from '@lyearn/core/utils/network/downloadFile';
import { ImportJobSampleCsvRow } from '@/types/schema';

const DEFAULT_FILE_NAME = 'download';

const downloadCsvFile = (rows: ImportJobSampleCsvRow[], fileName?: string) => {
  const csvContent = rows.reduce((acc, row) => {
    const rowValue = row.values.reduce((rowVal, value, index) => {
      rowVal += value.indexOf(',') === -1 ? value : `"${value}"`;

      return rowVal + (index !== row.values.length - 1 ? ',' : '');
    }, '');

    acc += rowValue + '\r\n';
    return acc;
  }, '');

  const blob = new Blob([csvContent], { type: 'text/csv' });
  downloadFile(blob, { fileName: `${fileName || DEFAULT_FILE_NAME}.csv` });
};

export default downloadCsvFile;
